module.exports = __webpack_public_path__ + "static/media/SCALE_Screen3.7b7670af.png";